import { render } from "./PartnerCarVerifyWildcard.vue?vue&type=template&id=74bdb462&scoped=true&ts=true"
import script from "./PartnerCarVerifyWildcard.vue?vue&type=script&lang=ts"
export * from "./PartnerCarVerifyWildcard.vue?vue&type=script&lang=ts"

import "./PartnerCarVerifyWildcard.vue?vue&type=style&index=0&id=74bdb462&scoped=true&lang=sass"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74bdb462"]])

export default __exports__